import { h } from "./../../utils/createElement";
import { __extends, __spreadArray } from "tslib";
import * as React from 'react';
import { castInto, emptyFn, trueFn } from '../../utils/helper';
import { consumeTheme } from '../../utils/theme';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
var CELL_HEIGHT = 32;
var WHEEL_SENSITIVITY = 1;
var ComboBox = (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentSelectedValues: _this.props.defaultSelectedValues || _this.props.columns.map(function (col) { return col[0].value; })
        };
        _this.rootDomRef = React.createRef();
        _this.columnItemRefs = _this.props.columns.map(function () { return React.createRef(); });
        _this.columnContainerRefs = _this.props.columns.map(function () { return React.createRef(); });
        _this.columnScrollTops = _this.props.columns.map(function () { return 0; });
        _this.prevTouchY = 0;
        _this.currentScrollColIndex = 0;
        _this.setCurrentPositionAsSelected = throttle(function (colIndex) {
            var cellIndex = Math.round(_this.columnScrollTops[colIndex] / CELL_HEIGHT);
            var value = _this.props.columns[colIndex][cellIndex].value;
            var prevValue = _this.getSelectedValues()[colIndex];
            if (value !== prevValue) {
                _this.setCellSelected(colIndex, value);
            }
        }, 25);
        _this.scrollToSelectedImmediately = function () {
            _this.columnItemRefs.forEach(function (ref, colIndex) {
                var columnDom = ref.current;
                if (!columnDom) {
                    return;
                }
                var selectedIndex = _this.getColSelectedItemIndex(colIndex);
                _this.scrollColumnTo(colIndex, selectedIndex * CELL_HEIGHT);
            });
        };
        _this.scrollToSelected = debounce(_this.scrollToSelectedImmediately, 100);
        _this.setCellSelected = function (colIndex, value, triggerScroll) {
            if (triggerScroll === void 0) { triggerScroll = false; }
            var selectedValues = _this.props.selectedValues || _this.state.currentSelectedValues;
            var nextValues = selectedValues.slice();
            nextValues[colIndex] = value;
            _this.props.onChange(nextValues);
            _this.setState({ currentSelectedValues: nextValues }, function () {
                triggerScroll && _this.scrollToSelectedImmediately();
            });
        };
        _this.handleTouchMove = function (e) {
            e.preventDefault();
            var screenY = e.touches[0].screenY;
            var delta = _this.prevTouchY - screenY;
            _this.prevTouchY = screenY;
            _this.scrollColumnBy(_this.currentScrollColIndex, delta, false);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, columns = _a.columns, shouldEnableValues = _a.shouldEnableValues, columnLabels = _a.columnLabels;
            var selectedValues = _this.getSelectedValues();
            var cls = classNames(prefixCls, className);
            var enableFuncs = shouldEnableValues || columns.map(function () { return trueFn; });
            return (h("div", { className: cls, style: style, ref: _this.rootDomRef, onTouchEnd: _this.scrollToSelectedImmediately, onTouchCancel: _this.scrollToSelectedImmediately },
                h("div", { className: classNames(prefixCls + "-indicator") }),
                columns.map(function (col, colIndex) {
                    var _a;
                    return (h("ul", { key: colIndex, className: classNames(prefixCls + "-column"), ref: _this.columnContainerRefs[colIndex], onTouchStart: _this.handleTouchStart.bind(_this, colIndex) },
                        h("div", { className: classNames(prefixCls + "-column-item", (_a = {}, _a[prefixCls + "-column-item-labeled"] = columnLabels[colIndex], _a)), ref: _this.columnItemRefs[colIndex] }, col.map(function (single) {
                            var _a;
                            var isSelected = single.value === selectedValues[colIndex];
                            var isDisabled = !enableFuncs[colIndex].apply(enableFuncs, __spreadArray(__spreadArray([], selectedValues.slice(0, colIndex)), [single.value]));
                            var cellCls = classNames(prefixCls + "-cell", (_a = {},
                                _a[prefixCls + "-cell-selected"] = isSelected,
                                _a[prefixCls + "-cell-disabled"] = isDisabled,
                                _a));
                            return (h("li", { key: single.value, className: cellCls, onClick: isDisabled ? undefined : function () { return _this.setCellSelected(colIndex, single.value, true); } }, single.cell || single.value));
                        })),
                        columnLabels[colIndex] && h("div", { className: classNames(prefixCls + "-column-label") }, columnLabels[colIndex])));
                })));
        };
        return _this;
    }
    ComboBox.prototype.getColSelectedItemIndex = function (colIndex) {
        var values = this.props.columns[colIndex];
        var selectedValues = this.getSelectedValues();
        var selectedIndex = values.findIndex(function (cell) { return cell.value === selectedValues[colIndex]; });
        return selectedIndex;
    };
    ComboBox.prototype.getSelectedValues = function () {
        var forceSelectedValues = this.props.selectedValues;
        var stateSelectedValues = this.state.currentSelectedValues;
        return forceSelectedValues || stateSelectedValues;
    };
    ComboBox.prototype.scrollColumnTo = function (colIndex, scrollTop) {
        this.columnScrollTops[colIndex] = castInto(scrollTop, [0, (this.props.columns[colIndex].length - 1) * CELL_HEIGHT]);
        this.updateTransforms(colIndex);
    };
    ComboBox.prototype.updateTransforms = function (colIndex) {
        var colItemDom = this.columnItemRefs[colIndex].current;
        var scrollTop = this.columnScrollTops[colIndex];
        colItemDom.style.transform = "translateY(" + -scrollTop + "px)";
    };
    ComboBox.prototype.scrollColumnBy = function (colIndex, delta, shouldScrollToSelected) {
        if (shouldScrollToSelected === void 0) { shouldScrollToSelected = true; }
        var targetScrollTop = this.columnScrollTops[colIndex] + delta;
        this.scrollColumnTo(colIndex, targetScrollTop);
        this.setCurrentPositionAsSelected(colIndex);
        shouldScrollToSelected && setTimeout(this.scrollToSelected, 30);
    };
    ComboBox.prototype.handleWheel = function (colIndex, e) {
        e.preventDefault();
        this.scrollColumnBy(colIndex, e.deltaY * WHEEL_SENSITIVITY);
    };
    ComboBox.prototype.handleTouchStart = function (colIndex, e) {
        this.prevTouchY = e.touches[0].screenY;
        this.currentScrollColIndex = colIndex;
    };
    ComboBox.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.selectedValues && !isEqual(prevProps.selectedValues, this.props.selectedValues)) {
            this.scrollToSelected();
        }
    };
    ComboBox.prototype.componentDidMount = function () {
        var _this = this;
        this.columnContainerRefs.forEach(function (ref, index) {
            ref.current.addEventListener('wheel', _this.handleWheel.bind(_this, index), { passive: false });
        });
        this.rootDomRef.current.addEventListener('wheel', function (e) { return e.preventDefault(); }, { passive: false });
        this.rootDomRef.current.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    };
    ComboBox.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return ComboBox;
}(React.Component));
export default ComboBox;
ComboBox.defaultProps = {
    prefixCls: 'dui-combobox',
    onChange: emptyFn,
    columnLabels: [],
};
